import React, { Component, ReactElement } from 'react';
import "./template_page_left_content.scss";
import { Page } from "../../../model/page";
import downIcon from "../../../assets/arrow_down.svg";
import PageLeftItemComponent from "../page_left_item_component/page_left_item_component";
import VideoPlayButton from "../../../common_components/video_play_button/video_play_button";
import C37THtmlPopup from "../../../left_items/c37t_html_popup/c37t_html_popup";
import ComponentsNavigation from "../../../left_items/components_navigation/components_navigation";
import StripesComponent from "../../../luiss_components/stripes_component/stripes_component";
import ReactPlayer from "react-player";
import C26TCourseLeftItem from "../../../left_items/c26t_corso_left_item/c26t_corso_left_item";
import { extraSmallLayout } from "../../../utils/device";
import { insertHtml } from "../../../utils/dom";
import { isMobileOnly } from "react-device-detect";
import C88BoxTitleImageCTA from '../../../left_items/c88_box_title_image_cta/c88_box_title_image_cta';
import C90ContactForm from '../../../left_items/c90_contact_form/c90_contact_form';


const TOP_BACKGROUND_DARK_OPACITY = 0.4;
const SVG_ID = "#svg_id";

interface TemplatePageLeftContentProps<P> {
    page: P;

    beforeLeftComponentsList: (page: P) => ReactElement | React.ReactNodeArray | React.ReactPortal | undefined;

    layoutColumns: number;
    language: string;
}

/**
 * The component renders the contents the should be on the left column on desktop and on the top on mobile,
 * with all the items the editor has decided to insert in the left column of the page.
 *
 * The placeholder content (the image or the video when they have been inserted)
 * does not belongs to this component in the desktop version,
 * because sometimes it has to be with the main column contents,
 * sometimes it has to disappear when the user scrolls the first time
 */
class TemplatePageLeftContent<P extends Page = Page> extends Component<TemplatePageLeftContentProps<P>> {

    state: {

        // true if there is a video and it is playing fullscreen on a mobile device
        playing: boolean
    };


    constructor(props: TemplatePageLeftContentProps<P>) {
        super(props);
        this.state = {
            playing: false
        }
    }

    headlines(page: P): ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {
        // hasImage is true if we have some placeholder content
        let hasImage = page.image || page.video;

        // mobileBackgroundImage is true if we have to show the placeholder content (only on mobile)
        let mobileBackgroundImage = hasImage && extraSmallLayout();

        let topBackground = {};
        let videoPars: { [key: string]: any } = {};

        if (mobileBackgroundImage) {

            if (page.image && !this.state.playing) {
                topBackground = {
                    backgroundImage:
                        /* top, transparent black, faked with gradient */
                        'linear-gradient(rgba(0, 0, 0, ' + TOP_BACKGROUND_DARK_OPACITY + '), rgba(0, 0, 0, ' + TOP_BACKGROUND_DARK_OPACITY + ')), url(' + page.image + ')'
                };
            }

            // if we have to show some placeholder content but the user has not inserted an image we write a warning
            if (!page.image) {
                console.warn("CONFIGURATION: The page with title '" + page.title + "' has a video but it's without an image poster");
            }

            videoPars = {
                controls: this.state.playing,
                playing: this.state.playing,
                playsinline: true,
                onPause: () => this.setState({ playing: false }),
                url: page.video
            };

            // if the editor has set a poster image, we render it
            if (page.image) {
                videoPars["light"] = page.image;
            }

            console.log("video props", videoPars);
        }

        // true if we have to show the mobile layout with the image
        if (mobileBackgroundImage) {
            // on MOBILE when we have an image to be shown,
            // we render an element at the top with the title and the image as its background

            return (
                <>
                    <div id="components-title-image" style={topBackground} className={this.state.playing ? "playing " : ""}>
                        <h1 className={"top-title p-name"}>{page.title}</h1>
                        <a href="#page-subtitle-mobile">
                            <svg className="down-icon">
                                <use xlinkHref={`${downIcon}${SVG_ID}`} />
                            </svg>
                        </a>
                        {
                            <div className="video-container">
                                {
                                    // if we have a video we will show the button and the video full screen if it's playing
                                    page.video &&
                                    <ReactPlayer {...videoPars} style={{
                                        width: "100%",
                                        height: "100%",
                                        position: "absolute",
                                        top: "0",
                                        bottom: "0"
                                    }} playIcon={
                                        <div className="play-button-container"
                                            onClick={() => this.setState({ playing: true })}>
                                            <VideoPlayButton startVideo={() => this.setState({ playing: true })} />
                                        </div>
                                    } />
                                }
                            </div>
                        }
                        {
                            // The mobile tabs should be rendered outside the left column on mobile to make the sticky work properly
                            extraSmallLayout() && page.left_column && page.left_column.filter(item => item.type === C37THtmlPopup.ID).map(item =>
                                <PageLeftItemComponent key={"left-item-" + item.type} item={item} layoutColumns={1} />
                            )
                        }
                    </div>
                    <p id="page-subtitle-mobile p-summary" className="editor-html"
                        {...insertHtml(page.subtitle ? page.subtitle : "")} />
                </>
            );
        } else {
            // on DESKTOP (and on mobile when there is no placeholder content) we show only the title and the subtitle
            return (
                <>
                    {
                        this.nearHeadlines(page)
                    }
                    {   // When we are on mobile we insert the page title even is we don't have one
                        (page.title || extraSmallLayout()) &&
                        <>
                        <h1 className={isMobileOnly ? "top-title p-name" : "top-title p-name extra-margin-top"}>{page.title}</h1>
                        {(this.props.page.path?.toString().includes('uniqueness')) ? 
                            <StripesComponent data={this.props.page.components} layoutColumns={this.props.layoutColumns} language={this.props.language} />
                        : null}
                        </>
                    }
                    {page.subtitle &&
                        <p key="page-title-text p-summary" className="text editor-html" {...insertHtml(page.subtitle)} />
                    }
                </>
            )
        }
    }

    beforeLeftComponentsList(page: P): ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {
        return undefined;
    }

    nearHeadlines(page: P): ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {
        return undefined;
    }


    render() {
        let page = this.props.page;

        if (!page) {
            return undefined;
        }

        let hasImage = page.image || page.video;
        console.log('page.left_column', page.left_column);
        return (
            <div className={"left-content " + (hasImage ? "has-image " : "")}>
                {
                    this.headlines(page)
                }
                {(page.image || page.video) && extraSmallLayout() &&
                    this.nearHeadlines(page)
                }
                {
                    // The mobile tabs should be rendered outside the left column on mobile to make the sticky work properly
                    extraSmallLayout() && page.internal_menu &&
                    <ComponentsNavigation sections={page.internal_menu} type={"page-sections"} data="" />
                }
                {
                    this.beforeLeftComponentsList(page)
                }
                {/* The list of items the editor has inserted on the left column,
                    the data-aos attributes are to make the container div fade in when the user scrolls the first time */}
                <div data-aos="fade-up" data-aos-offset={(page.image || page.video) ? 5 : -2} data-aos-anchor="#root" data-aos-anchor-placement="top-top">
                    {
                        // For each item on the left column we render a PageLeftItemComponent,
                        // which recognises the component type and renders it properly
                        page.left_column && page.left_column
                            .filter(item => item.type)
                            .filter(item => item.type !== C37THtmlPopup.ID || !extraSmallLayout())
                            .filter(item => item.type !== C26TCourseLeftItem.ID)
                            .filter(item => item.type !== C88BoxTitleImageCTA.ID)
                            .map((item, index) =>
                                <PageLeftItemComponent key={"left-item-" + index} item={item} layoutColumns={this.props.layoutColumns} />
                            )
                    }
                    {
                        !extraSmallLayout() && page.internal_menu &&
                        <ComponentsNavigation sections={page.internal_menu} type={"page-sections"} data="" />
                    }
                </div>
            </div>
        );
    }
}

export default TemplatePageLeftContent;
